import { render, staticRenderFns } from "./CustomerDashOutro.vue?vue&type=template&id=8b6e2848&scoped=true"
import script from "./CustomerDashOutro.vue?vue&type=script&lang=js"
export * from "./CustomerDashOutro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6e2848",
  null
  
)

export default component.exports